import { Stack, Typography } from '@mui/material';
import { useConfigurationState } from '../lib/contexts/ConfigurationContext/ConfigurationContext';
import { useScreenLargerThan } from '../lib/hooks/breakpoint-hooks';

const Unauthorized = () => {
    const globalContextState = useConfigurationState();
    const isLargerThanSmall = useScreenLargerThan('sm');

    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            sx={{
                width: '100%',
                height: `calc(100vh - ${globalContextState.headerOffsetHeight}px)`
            }}>
            <Typography
                sx={{
                    textAlign: 'center',
                    fontSize: isLargerThanSmall ? 56 : 26,
                    fontWeight: 300
                }}>
                403 Unauthorized
            </Typography>
            <Typography
                sx={{
                    textAlign: 'center',
                    fontSize: isLargerThanSmall ? 26 : 13,
                    fontWeight: 400
                }}>
                You need to have special priviliges to see this page
            </Typography>
        </Stack>
    );
};

export default Unauthorized;
